import { useTranslation } from 'contexts/Localization'
import { FC, useCallback, useState } from 'react'
import styled from 'styled-components'
import { Box, Button, Checkbox, Flex, InjectedModalProps, Link, Modal, Text } from 'vvs-uikit'

const URL = process.env.REACT_APP_FULCROM_URL || 'https://perps.vvs.finance/'

interface PerpetualsTncModal extends InjectedModalProps {
  onConfirm: () => void
}

const StyledText = styled(Text)`
  a {
    text-decoration: underline;
  }
`

const PerpetualsTncModal: FC<PerpetualsTncModal> = ({ onConfirm, onDismiss }) => {
  const { t } = useTranslation()

  const [isConfirm, setIsConfirm] = useState(false)

  const handleConfirm = useCallback(() => {
    onConfirm()
    window.open(URL, '_blank')
    onDismiss()
  }, [onConfirm, onDismiss])

  return (
    <Modal
      title={t('VVS Perpeatuals')}
      onDismiss={onDismiss}
      style={{ maxWidth: '460px' }}
      bodyPadding="0 24px 24px 24px"
    >
      <Text>
        {t(
          'You are about to access a third party service owned and operated by Fulcrom (“Third Party Services”) . Your use of the Third Party Services will be at your own risk. Any use of the Third Party Services, and any information you provide, will be subject to and governed by the policies and terms of Fulcrom, and may be subject to separate fees charged by Fulcrom.',
        )}
      </Text>
      <Flex alignItems="center" my="16px">
        <Box mr="12px">
          <Checkbox onChange={() => setIsConfirm(!isConfirm)} hasBorder />
        </Box>
        <StyledText bold>
          {t('I acknowledge having read and agree to the ')}
          <Link href="https://fulcrom.finance/docs/termsandconditions.pdf" color="inherit" external>
            {t('Fulcrom Terms and Conditions.')}
          </Link>
        </StyledText>
      </Flex>
      <Button disabled={!isConfirm} onClick={handleConfirm}>
        {t('Continue')}
      </Button>
    </Modal>
  )
}

export default PerpetualsTncModal
